import { render, staticRenderFns } from "./SendBulkSms.vue?vue&type=template&id=8e0b29c8&scoped=true&"
import script from "./SendBulkSms.vue?vue&type=script&lang=js&"
export * from "./SendBulkSms.vue?vue&type=script&lang=js&"
import style0 from "./SendBulkSms.vue?vue&type=style&index=0&id=8e0b29c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0b29c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e0b29c8')) {
      api.createRecord('8e0b29c8', component.options)
    } else {
      api.reload('8e0b29c8', component.options)
    }
    module.hot.accept("./SendBulkSms.vue?vue&type=template&id=8e0b29c8&scoped=true&", function () {
      api.rerender('8e0b29c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/components/SendBulkSms.vue"
export default component.exports